const Roles = {
  admin: "Admin",
  authority: "Authority",
  editor: "Editor",
  operator: "Operator",
  startListExporter: "StartListExporter",
  photograph: "Photograph",
};

Roles.all = Object.values(Roles);
Roles.privileged = [Roles.admin, Roles.authority];
Roles.operators = [Roles.admin, Roles.authority, Roles.operator];
Roles.editors = [Roles.admin, Roles.authority, Roles.editor];
Roles.registrationEditors = [Roles.admin, Roles.authority, Roles.editor];
Roles.registrationOperators = [Roles.admin, Roles.authority, Roles.editor, Roles.operator];
Roles.photoEditors = [Roles.admin, Roles.authority, Roles.editor, Roles.photograph];

const RoleNames = {
  Admin: "Administrátor",
  Authority: "Autorita",
  Editor: "Editor",
  Operator: "Operátor",
  StartListExporter: "Exportér startovky",
  Photograph: "Fotograf",
};

const AuthenticatedRole = "Authenticated";
const PublicRole = "Public";

export { RoleNames, Roles, AuthenticatedRole, PublicRole };
